import React from 'react';
import { IReduxFormTextArea } from '../../../models/IReduxFormHandlers';
import ReduxFormErrorHandler from './ReduxFormErrorHandler';
import { injectIntl } from 'react-intl';

const ReduxFormTextArea: React.FC<IReduxFormTextArea> = props => {
  const errorClass = `${(props.meta.error && props.meta.touched) || props.meta.warning ? 'error' : ''}`;
 /*  const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder; */
  return (
    <React.Fragment>
      <textarea
        {...props.input}
      /*   placeholder={_placeholder} */
        className={props.className + ' ' + errorClass}
        readOnly={props.readOnly}
        rows={props.rows}
      >
      </textarea>
      <ReduxFormErrorHandler meta={props.meta} min={props.min} max={props.max} />
    </React.Fragment>
  );
};

export default injectIntl(ReduxFormTextArea);
